import { render, staticRenderFns } from "./DashboardWelcome.vue?vue&type=template&id=5bd21a73&scoped=true&"
import script from "./DashboardWelcome.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcome.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWelcome.vue?vue&type=style&index=0&id=5bd21a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd21a73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VImg,VTooltip})
